import { render, staticRenderFns } from "./ItemCardMetaData.vue?vue&type=template&id=fb75771e&scoped=true"
import script from "./ItemCardMetaData.vue?vue&type=script&lang=ts"
export * from "./ItemCardMetaData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb75771e",
  null
  
)

export default component.exports